// extracted by mini-css-extract-plugin
export var copyableField = "_rp-4";
export var customerBadge = "_rp-0";
export var customerInfoTitle = "_rp-2";
export var details = "_rp-1";
export var dropdownContainer = "_rp-5";
export var dropdownImage = "_rp-6";
export var editAssigneeForm = "_rp-a";
export var editButton = "_rp-3";
export var email = "_rp-7";
export var hidden = "_rp-d";
export var input = "_rp-8";
export var saveButton = "_rp-b";
export var shopifyIcon = "_rp-c";
export var suggestionBadge = "_rp-e";
export var suggestionText = "_rp-f";
export var username = "_rp-9";